import React from 'react';
import { Typography, Button } from '@material-ui/core';
import { appRoutes } from 'routes';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import useStyles from './useStyles';

const WelcomePage = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.paper}>
        <Typography variant="h1" className={classes.headerText}>
          {t('components.BuyerDashboard.WelcomePage.header')}
        </Typography>
        <Typography variant="body1">{t('components.BuyerDashboard.WelcomePage.description')}</Typography>
        <Button to={appRoutes.surveyPath()} component={RouterLink} className={classes.button}>
          {t('components.BuyerDashboard.WelcomePage.button')}
        </Button>
      </div>
    </div>
  );
};

export default WelcomePage;



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/WelcomePage/WelcomePage.js